import React, { useMemo } from "react";
import { useMsal } from "@azure/msal-react";
import QuickSearch from "../components/Dashboard/QuickSearch/QuickSearch";
import QuickSave from "../components/Dashboard/QuickSave/QuickSave";
import RoutesList from "../components/Dashboard/RoutesList/RoutesList";
import RecordsTerminalEX from "../components/Dashboard/TerminalRecords/RecordsTerminalEX";
import RecordsTerminalDR from "../components/Dashboard/TerminalRecords/RecordsTerminalDR";
import TerminalExCodes from "../components/Dashboard/TerminalCodes/TerminalEXCodes";
import TerminalDRCodes from "../components/Dashboard/TerminalCodes/TerminalDRCodes";
import WaitingChangesCard from "../components/Dashboard/WaitingChangesCard";
import ScheduledChangesCard from "../components/Dashboard/ScheduledChangesCard";
import DataImportCard from "../components/Dashboard/DataImportCard";
import DashboardIcon from "../assets/images/carbon_dashboard_rgb_red.svg";
import { Container, Row, Col } from "react-bootstrap";
import "../assets/styles/dashboard.scss";

const Dashboard = () => {
  const { instance, accounts } = useMsal();
  const activeAccount = instance.getActiveAccount() || accounts?.[0];

  const isSuperuser = useMemo(() => {
    const claims = activeAccount?.idTokenClaims || {};
    const raw = claims.roles || claims.role || claims.groups;
    const roles = Array.isArray(raw) ? raw : raw ? [raw] : [];

    if (roles.includes("ROLE_SUPERUSER")) return true;

    try {
      const stored = JSON.parse(localStorage.getItem("user") || "null");
      const storedRoles = Array.isArray(stored?.roles)
        ? stored.roles
        : stored?.role
        ? [stored.role]
        : [];
      return storedRoles.includes("ROLE_SUPERUSER");
    } catch {
      return false;
    }
  }, [activeAccount]);

  return (
    <div className="dashboard-container">
      <Container fluid>
        <Row className="dashboard-hero align-items-center mb-3">
          <Col className="d-flex align-items-center dashboard-hero__content">
            <img
              src={DashboardIcon}
              alt="Dashboard Pin"
              className="dashboard-hero__icon"
            />
            <div>
              <h3 className="dashboard-hero__title">Dashboard</h3>
              <p className="dashboard-hero__subtitle mb-0">
                Szybki podgląd danych operacyjnych i zaplanowanych zmian.
              </p>
            </div>
          </Col>
        </Row>

        <Row className="dashboard-cards-row g-2 mb-2">
          {isSuperuser && (
            <>
              <Col xs={12} sm="auto">
                <WaitingChangesCard />
              </Col>
              <Col xs={12} sm="auto">
                <ScheduledChangesCard />
              </Col>
            </>
          )}

          {/* Kafelek importu jest widoczny dla obu ról — strona /data-import
              jest dostępna również dla ROLE_USER, który widzi importy swojego oddziału.
              Narracja kafelka zmienia się zależnie od roli, bo zwykły użytkownik
              nie ma uprawnień do akceptowania importów. */}
          <Col xs={12} sm="auto">
            <DataImportCard isSuperUser={isSuperuser} />
          </Col>
        </Row>

        <Row className="dashboard-section-row g-3 mb-3">
          <Col xs={12} xl={6}>
            <QuickSave />
          </Col>
          <Col xs={12} xl={6}>
            <QuickSearch />
          </Col>
        </Row>

        <Row className="dashboard-section-row g-3 mb-3">
          <Col xs={12} sm={6} xl={3}>
            <RecordsTerminalDR />
          </Col>
          <Col xs={12} sm={6} xl={3}>
            <RecordsTerminalEX />
          </Col>
          <Col xs={12} sm={6} xl={3}>
            <TerminalDRCodes />
          </Col>
          <Col xs={12} sm={6} xl={3}>
            <TerminalExCodes />
          </Col>
        </Row>

        <Row className="dashboard-section-row g-3">
          <Col xs={12}>
            <RoutesList />
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Dashboard;
